module.exports = __webpack_public_path__ + "assets/media/day6.fb5fcdc9.mp3";